import React, { FC, MouseEvent } from 'react';
import { Hyperlink } from '../../../../components/Hyperlink';
import { DecisionSeparator } from '../../../../decision/components/decision-separator/DecisionSeparator';
import { SearchDecision } from '../../../../decision/decision.types';
import styles from './search_decision_keywords.module.scss';
import { PopoverFactoryRenderer } from '../../../../components/popovers/PopoverFactoryRenderer';
import { PopoverSelectionFromDataAttribute } from '../../../../components/popovers/PopoverSelectionFromDataAttribute';

type Props = {
  matchedLawArticles: SearchDecision['matchedLawArticles'];
  keywords: { html: string; label: string; id: number }[];
  decisionId: string;
  onArticleClicked: (event: MouseEvent<HTMLAnchorElement>) => void;
};

export const SearchDecisionKeywords: FC<Props> = ({
  matchedLawArticles,
  decisionId,
  keywords,
  onArticleClicked,
}) => {
  const source = 'search-decision-matched-article';
  const displayPopover = (element: HTMLElement) => (
    <PopoverSelectionFromDataAttribute element={element} source={source} />
  );

  const shouldDisplayArticleSeparator = (index: number) => {
    return (
      index < matchedLawArticles.length - 1 ||
      (index === matchedLawArticles.length - 1 && keywords.length > 0)
    );
  };
  return (
    <div>
      <PopoverFactoryRenderer renderTemplate={displayPopover}>
        <ul className={styles.wrapper}>
          {matchedLawArticles.map((matchedLawArticle, articleIndex) => (
            <li key={`${decisionId}-${matchedLawArticle.articleId}`}>
              <Hyperlink
                href={matchedLawArticle.url}
                source={source}
                className={styles.article}
                data-doctrine-popover
                data-legislation={matchedLawArticle.articleId}
                onClick={onArticleClicked}
              >
                {matchedLawArticle.title}
              </Hyperlink>

              {shouldDisplayArticleSeparator(articleIndex) && (
                <DecisionSeparator />
              )}
            </li>
          ))}
          {keywords.map((keyword, keywordIndex) => (
            <li key={keyword.id} className={styles.keyword}>
              <span dangerouslySetInnerHTML={{ __html: keyword.html }} />
              {keywordIndex < keywords.length - 1 && <DecisionSeparator />}
            </li>
          ))}
        </ul>
      </PopoverFactoryRenderer>
    </div>
  );
};
